import { render, staticRenderFns } from "./opt_groups.vue?vue&type=template&id=38fbe0e0&scoped=true&lang=html"
import script from "./opt_groups.vue?vue&type=script&lang=js"
export * from "./opt_groups.vue?vue&type=script&lang=js"
import style0 from "./opt_groups.vue?vue&type=style&index=0&id=38fbe0e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbe0e0",
  null
  
)

export default component.exports